import React from 'react';
import shallowCompare from '../../lib/shallowCompare';
import styles from './index.sass';

class DelectableRating extends React.Component {
  static propTypes = {
    rating: React.PropTypes.number.isRequired,
    count: React.PropTypes.number,
    className: React.PropTypes.string,
    style: React.PropTypes.object
  };

  static defaultProps = {
    className: '',
    style: {}
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    let { rating, count } = this.props;
    let classes = `${styles.delectableRatingBadge} ${this.props.className}`;

    if(rating >= 9.0) {
      classes += ` ${styles.best}`;
    } else if(rating >= 8.0) {
      classes += ` ${styles.good}`;
    } else if(rating >= 7.0) {
      classes += ` ${styles.ok}`;
    } else {
      classes += ` ${styles.bad}`;
    }

    let noun = (count === 1) ? 'rating' : 'ratings';

    return (
      <span className={classes} style={this.props.style}>
        <span className={styles.rating}>{rating === 10.0 ? 10 : rating.toFixed(1)}</span>
        {count ? <span className={styles.message}>{count} {noun} on Delectable</span> : null}
      </span>
    );
  }
}

export default DelectableRating;



// WEBPACK FOOTER //
// banquet/components/DelectableRating/index.js